import { ColorSpectrum } from "../Pages/Data/Visualize/DataReview/Types/ColorSpectrum";
import { DSADisplayScale, isQEEGDSASourceModality } from "../Pages/Data/Visualize/DataReview/Types/AnalysisDetails";
import { DEFAULT_SPECTROGRAM_TRACE_SETTINGS, RenderStrategy } from "../Pages/Data/Visualize/DataReview/Types/Trace";

type LabelSetting = {
    name: string
    min: number
    max: number
    color: string
    autoscale: boolean
    lowerBound?: number
    upperBound?: number
    colorSpectrum?: ColorSpectrum
    displayScale?: DSADisplayScale
}

type MaybeLabelSetting = {
    name?: string
    min?: number
    max?: number
    lowerBound?: number
    upperBound?: number
    color?: string
    autoscale?: boolean
    colorSpectrum?: ColorSpectrum
    displayScale?: DSADisplayScale
}

type WithRenderStrategy = {
    renderStrategy: RenderStrategy
}


export const LABEL_SETTINGS: Record<string, LabelSetting> = {
    "ABP_Dias": {'name': 'Diastolic ABP', "min": 0, "max": 200, 'color': '#FF0000', 'autoscale': true},
    "ABP_Mean": {'name': 'Mean ABP', "min": 0, "max": 200, 'color': '#FF0000', 'autoscale': true},
    "ABP_na": {'name': 'ABP', "min": 0, "max": 250, 'color': '#FF0000', 'autoscale': true},
    "ABP_Syst": {'name': 'Systolic ABP', "min": 0, "max": 200, 'color': '#FF0000', 'autoscale': true},
    "ART_Dias": {'name': 'Diastolic ABP', "min": 0, "max": 200, 'color': '#FF0000', 'autoscale': true},
    "ART_Mean": {'name': 'Mean ABP', "min": 0, "max": 200, 'color': '#FF0000', 'autoscale': true},
    "ART_na": {'name': 'ABP', "min": 0, "max": 250, 'color': '#FF0000', 'autoscale': true},
    "ART_Syst": {'name': 'Systolic ABP', "min": 0, "max": 200, 'color': '#FF0000', 'autoscale': true},
    "ART1_Dias": {'name': 'Diastolic ABP', "min": 0, "max": 200, 'color': '#FF0000', 'autoscale': true},
    "ART1_Mean": {'name': 'Mean ABP', "min": 0, "max": 200, 'color': '#FF0000', 'autoscale': true},
    "ART1_na": {'name': 'ABP', "min": 0, "max": 250, 'color': '#FF0000', 'autoscale': true},
    "ART1_Syst": {'name': 'Systolic ABP', "min": 0, "max": 200, 'color': '#FF0000', 'autoscale': true},
    "BIS_na": {'name': 'BIS', "min": 0, "max": 100, 'color': '#000000', 'autoscale': true},
    "CO2_na": {'name': 'CO2', "min": 0, "max": 100, 'color': '#000000', 'autoscale': true},
    "CPP_na": {'name': 'CPP', "min": 40, "max": 120, 'color': '#2600BD', 'autoscale': true},
    "CPP2_na": {'name': 'CPP', "min": 40, "max": 120, 'color': '#2600BD', 'autoscale': true},
    "CVP_Mean": {'name': 'CVP', "min": 0, "max": 20, 'color': '#000000', 'autoscale': true},
    "CVP_na": {'name': 'CVP', "min": 0, "max": 20, 'color': '#000000', 'autoscale': true},
    "ECG_II": {'name': 'ECG II', "min": -0.5, "max": 2, 'color': '#49B500', 'autoscale': false},
    "EtCO2_na": {'name': 'EtCO2', "min": 15, "max": 100, 'color': '#009F4E', 'autoscale': true},
    "HR_na": {'name': 'HR', "min": 30, "max": 240, 'color': '#C37400', 'autoscale': true},
    "IC1_Mean": {'name': 'Mean ICP', "min": 0, "max": 100, 'color': '#46B300', 'autoscale': true},
    "IC1_na": {'name': 'ICP', "min": 0, "max": 100, 'color': '#46B300', 'autoscale': true},
    "IC2_Mean": {'name': 'Mean ICP', "min": 0, "max": 100, 'color': '#46B300', 'autoscale': true},
    "IC2_na": {'name': 'ICP', "min": 0, "max": 100, 'color': '#46B300', 'autoscale': true},
    "ICP_Mean": {'name': 'Mean ICP', "min": 0, "max": 100, 'color': '#46B300', 'autoscale': true},
    "ICP_na": {'name': 'ICP', "min": 0, "max": 100, 'color': '#46B300', 'autoscale': true},
    "ICP1_Dias": {'name': 'ICP', "min": 0, "max": 100, 'color': '#46B300', 'autoscale': true},
    "ICP1_Mean": {'name': 'Mean ICP', "min": 0, "max": 100, 'color': '#46B300', 'autoscale': true},
    "ICP1_na": {'name': 'ICP', "min": 0, "max": 100, 'color': '#46B300', 'autoscale': true},
    "ICP1_Syst": {'name': 'ICP', "min": 0, "max": 100, 'color': '#46B300', 'autoscale': true},
    "ICP2_Dias": {'name': 'ICP', "min": 0, "max": 100, 'color': '#46B300', 'autoscale': true},
    "ICP2_Mean": {'name': 'Mean ICP', "min": 0, "max": 100, 'color': '#46B300', 'autoscale': true},
    "ICP2_na": {'name': 'ICP', "min": 0, "max": 100, 'color': '#46B300', 'autoscale': true},
    "ICP2_Syst": {'name': 'ICP', "min": 0, "max": 100, 'color': '#46B300', 'autoscale': true},
    "LAP_Mean": {'name': 'Systolic LAP', "min": 0, "max": 100, 'color': '#FF0000', 'autoscale': true},
    "NBP_Dias": {'name': 'Diastolic NBP', "min": 0, "max": 100, 'color': '#FF0000', 'autoscale': true},
    "NBP_Mean": {'name': 'Mean NBP', "min": 0, "max": 100, 'color': '#FF0000', 'autoscale': true},
    "NBP_Syst": {'name': 'Systolic NBP', "min": 0, "max": 100, 'color': '#FF0000', 'autoscale': true},
    "P_Mean": {'name': 'Mean P', "min": 0, "max": 100, 'color': '#FF0000', 'autoscale': true},
    "P_na": {'name': 'P', "min": 0, "max": 100, 'color': '#FF0000', 'autoscale': true},
    "P1_Mean": {'name': 'P1', "min": 0, "max": 100, 'color': '#FF0000', 'autoscale': true},
    "P1_na": {'name': 'P1', "min": 0, "max": 100, 'color': '#FF0000', 'autoscale': true},
    "PAP_Dias": {'name': 'Diastolic PAP', "min": 0, "max": 100, 'color': '#FF0000', 'autoscale': true},
    "PAP_Mean": {'name': 'Mean PAP', "min": 0, "max": 100, 'color': '#FF0000', 'autoscale': true},
    "PAP_Syst": {'name': 'Systolic PAP', "min": 0, "max": 100, 'color': '#FF0000', 'autoscale': true},
    "PbtO2_na": {'name': 'PbtO2', "min": 0, "max": 100, 'color': '#7C00B3', 'autoscale': true},
    "PLETH_na": {'name': 'Pleth', "min": 0, "max": 100, 'color': '#7F00D0', 'autoscale': true},
    "RESP_na": {'name': 'Resp', "min": -0.5, "max": 1, 'color': '#7F00D0', 'autoscale': true},
    "RR_na":  {'name': 'RR', "min": 18, "max": 25, 'color': '#62A978', 'autoscale': true},
    "SpO2_na": {'name': 'SpO2', "min": 85, "max": 100, 'color': '#8E7500', 'autoscale': true},
    "T1_na": {'name': 'T1', "min": 0, "max": 42, 'color': '#FF8E74', 'autoscale': true},
    "T2_na": {'name': 'T2', "min": 30, "max": 42, 'color': '#FF8E74', 'autoscale': true},
    "Tcereb_na": {'name': 'Tcereb', "min": 30, "max": 42, 'color': '#FF8E74', 'autoscale': true},
    "Tcore_na": {'name': 'Tcore', "min": 30, "max": 42, 'color': '#FF8E74', 'autoscale': true},
    "Temp_na": {'name': 'Temp', "min": 30, "max": 42, 'color': '#FF8E74', 'autoscale': true},
    "Tesop_na": {'name': 'Tesop', "min": 30, "max": 42, 'color': '#FF8E74', 'autoscale': true},
    "Tskin_na": {'name': 'Tskin', "min": 30, "max": 42, 'color': '#FF8E74', 'autoscale': true},
    "UVP_Mean": {'name': 'UVP', "min": 0, "max": 100, 'color': '#7C00B3', 'autoscale': true},
    "UVP_na": {'name': 'UVP', "min": 0, "max": 100, 'color': '#7C00B3', 'autoscale': true},

    // Analytics
    "CPPOpt": {'name': "CPPopt", "min": 40, "max": 120, 'color': "#FF7043", 'autoscale': false},
    "CPPOpt_LLA": {'name': "CPPopt LLA", "min": 40, "max": 120, 'color': "#FF7043", 'autoscale': false},
    "CPPOpt_ULA": {'name': "CPPopt ULA", "min": 40, "max": 120, 'color': "#FF7043", 'autoscale': false},
    "CPPOpt (multi-window)": {'name': "CPPopt", "min": 40, "max": 120, 'color': "#FF7043", 'autoscale': false},
    "CPPOpt_LLA (multi-window)": {'name': "CPPopt LLA", "min": 40, "max": 120, 'color': "#FF7043", 'autoscale': false},
    "CPPOpt_ULA (multi-window)": {'name': "CPPopt ULA", "min": 40, "max": 120, 'color': "#FF7043", 'autoscale': false},
    "MAPOpt": {'name': "MAPopt", "min": 20, "max": 120, 'color': "#FF7043", 'autoscale': false},
    "MAPOpt_LLA": {'name': "MAPopt LLA", "min": 20, "max": 120, 'color': "#FF7043", 'autoscale': false},
    "MAPOpt_ULA": {'name': "MAPopt ULA", "min": 20, "max": 120, 'color': "#FF7043", 'autoscale': false},
    "MAPOpt (multi-window)": {'name': "MAPopt", "min": 20, "max": 120, 'color': "#FF7043", 'autoscale': false},
    "MAPOpt_LLA (multi-window)": {'name': "MAPopt LLA", "min": 20, "max": 120, 'color': "#FF7043", 'autoscale': false},
    "MAPOpt_ULA (multi-window)": {'name': "MAPopt ULA", "min": 20, "max": 120, 'color': "#FF7043", 'autoscale': false},
    "PRx": {'name': "PRx", "min": -1, "max": 1, "lowerBound": 1, "upperBound": -1, "color": "#FF7043", "colorSpectrum": ColorSpectrum.RED_YELLOW_GREEN, "autoscale": false},
    "COx": {'name': "COx", "min": 1, "max": 0, "lowerBound": 1, "upperBound": 0, "color": "#FF7043", "colorSpectrum": ColorSpectrum.RED_YELLOW_GREEN, "autoscale": false},
    "COIN": {'name': "COIN", "min": -100, "max": 0, "color": "#FF7043", "autoscale": false},

    "qEEG_DSA": {'name': "qEEG DSA", "min": 0, "max": 20, 'color': "#FF7043", 'autoscale': false, ...DEFAULT_SPECTROGRAM_TRACE_SETTINGS},
}

function getRenderStrategy(key: string | undefined, renderStrategy: RenderStrategy) {
    switch (renderStrategy) {
        case RenderStrategy.LINE:
        case RenderStrategy.LINE_STEP:
            return key?.toLowerCase().startsWith("pupillary") ? RenderStrategy.LINE_STEP : renderStrategy
        default:
            return renderStrategy
    }
}

export function applyModalitySpecificDefaults<T extends WithRenderStrategy>(record: T, key: string | undefined, renderStrategy: RenderStrategy = RenderStrategy.LINE): T & MaybeLabelSetting {
    let result: T & MaybeLabelSetting = {
        min: undefined,
        max: undefined,
        color: undefined,
        autoscale: undefined,
        colorSpectrum: undefined,
        displayScale: undefined,
        lowerBound: undefined,
        upperBound: undefined,
        ...record
    }

    result.renderStrategy = getRenderStrategy(key, renderStrategy)

    if (!key) {
        return result
    }

    // Source DSA keys carry the channel group (`qEEG_DSA_LeftHemisphere`), so they
    // share the analytic's settings by prefix rather than by exact key -- but only
    // for spectrograms, so legacy line/heatmap configs keep their old (no-defaults)
    // behavior.
    const defaults = LABEL_SETTINGS[key]
        ?? (result.renderStrategy === RenderStrategy.SPECTROGRAM && isQEEGDSASourceModality(key) ? LABEL_SETTINGS["qEEG_DSA"] : undefined)

    if (defaults === undefined) {
        return result
    }

    const defaultsCopy = { ...defaults }
    Object.assign(result, defaultsCopy)

    if (renderStrategy === RenderStrategy.HEATMAP) {
        result.lowerBound = defaultsCopy.lowerBound ?? defaultsCopy.min
        result.upperBound = defaultsCopy.upperBound ?? defaultsCopy.max
        result.colorSpectrum = defaultsCopy.colorSpectrum ?? ColorSpectrum.INFERNO
    }

    if (renderStrategy === RenderStrategy.SPECTROGRAM) {
        result.displayScale = defaultsCopy.displayScale
        result.colorSpectrum = defaultsCopy.colorSpectrum ?? ColorSpectrum.DISCRETE_RGB
        result.lowerBound = defaultsCopy.lowerBound
        result.upperBound = defaultsCopy.upperBound
    }

    return result
}
